import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NgWizardService } from 'ng-wizard';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-whitelist-scheme-user',
  templateUrl: './whitelist-scheme-user.component.html',
  styleUrls: ['./whitelist-scheme-user.component.scss']
})
export class WhitelistSchemeUserComponent implements OnInit {
  flag = true;
  @Output() whiteListData: EventEmitter<boolean> = new EventEmitter();

  @Input() schemeId = "";
  whiteListUser: any = []
  page = 1;
  getPaginationCount;

  excelFormat: any = {};
  excelArray: any = [];
  excelData: any = [];
  cartonLocalFlags: any = {};
  schemeWhiteList: any = []
  schemeConfig: any = {}

  constructor(
    private ngWizardService: NgWizardService,
    private router: Router,
    private exportExcelService: ExportExcelService,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration

  ) {
  }

  ngOnInit() {


    this.schemeConfig = JSON.parse(localStorage.getItem('scheme_config'))
    console.log("cap", this.schemeId)
    if (this.schemeConfig.scheme_id != '' && this.schemeConfig.scheme_id != null && this.schemeConfig.scheme_id != undefined) {
      this.schemeId = this.schemeConfig.scheme_id
      this.getSchemeWhitelist()
    }
    this.getSchemeWhitelist()

  }

  getSchemeWhitelist() {
    this.apiService.get(this.apiConfig.schemeWhitelist + `?scheme_id=${this.schemeId}`).subscribe((res: any) => {
      console.log(res)
      this.schemeWhiteList = res.data;
    })
  }
  submit() {
    this.whiteListData.emit(this.flag);
  }

  uploadExcel() {
    this.router.navigate([`/hubAdmin/scheme-excel-upload/${this.schemeId}/2`])
  }

  DownloadReportExcel() {
    console.log("here", this.excelData, this.excelArray)
    this.exportExcelService.DownloadReportExcel('Whitelist_outlet', this.excelData, this.excelArray);
  }

  paginationClick(e) {
    console.log(e);
    this.page = e;

  }
}
